const BRAND = '#23928B';
const BRAND_DARK = '#1d7a74';

const LOGO_SVG = `<svg width="120" height="30" viewBox="0 0 298 75" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M246.5 46.75L246 47.5V54.75L246.5 55.25L254.25 55V47L246.5 46.75ZM124.75 23.75L124.25 24.25V54.5L124.75 55.25H131.5L132 54.5V25L131.5 23.75H124.75ZM223.25 23.5L219 25.5L216.25 28.75L215.5 31.5V34.5L216 36.5L217.5 38.75L219.5 40.25L223.5 42L228.5 43.25L230.5 44.25L232 45.75V47.75L230 49.5L226 49.75L221.5 48.5L217.25 46L214 51L214.5 51.75L218.25 54L222 55.25L226.5 56L232.5 55.25L235.25 54L236.75 52.75L238.25 50.5L239.25 46.5L238.75 42.75L237.5 40.75L235.5 39L231.25 37L229 36.5L224 34.5L222.75 33.25L222.5 31.75L223 30.75L224.75 29.5L227.75 29.25L231.5 30.25L235.25 32.25L236.25 31.25L238.5 27L237.25 26L232 23.75L228.5 23.25L223.25 23.5ZM182.25 25.75V27.5L183.25 30.5L184.25 32L189.25 30.25H195.75L197.5 31L199.25 32.5L200.25 34.25V36L199.75 36.5H198.75L198 36L193.75 35.5L188.5 35.75L185 36.75L182 38.75L180.5 40.75L179.25 44.25V47.75L180 50.25L181.25 52.25L184.5 54.75L188.75 56H192.25L195.5 55.25L197.25 54.5L199 53H199.75L200.25 53.5V54.75L200.75 55.25H207.5L207.75 33L206.75 29.75L205.75 28L203.25 25.5L202 24.75L198 23.5H189.5L185.25 24.5L182.25 25.75ZM186.75 46.75V44.75L187.25 43.75L188.75 42.25L190.75 41.25H197.5L199.25 41.75L200.5 42.75V45L199.75 46.75L197.75 48.75L195.75 49.75L193.5 50.25L189.75 49.75L188.5 49L186.75 46.75ZM114.75 23.75H107.75L107.25 24.5L107.5 25.75L106.75 26.75H106.25L105.25 25.75L101.75 23.75L97.75 23L94.25 23.25L89.75 24.75L87.5 26.25L85.75 28L83.25 32.25L82.5 35.5V40.5L83.25 43.75L84.5 46.25L86.75 49L91.5 52L94.5 52.75H99.25L101.25 52.25L104 51L106.75 48.75H107.25L107.75 49.75L107.25 51V52.5L106.25 54.75L104.5 56.75L103 57.75L99 58.75L94.75 58.5L91 57.5L88 55.75L86.75 55.5L84 60.25V61L84.5 61.5L87.5 63L91.5 64.25L98.75 65L102 64.75L106.25 63.75L109.25 62.25L112 59.75L114.5 54.75L115 51.25L114.75 23.75ZM97.75 29.5L101 29.75L104.25 31.25L106.75 34.25L107.75 38.25L107 41.25L104 44.75L102.25 45.75L99.25 46.5L95.75 46L93.75 45L91 42L90 38.75L90.25 35.75L90.75 34.25L92 32.5L94.5 30.5L97.75 29.5ZM282.75 15L281.75 15.75V23L280.75 23.75H278L277.75 24.25V29.75L278.25 30.25H280.75L281.75 31L282 50.25L283.25 52.75L284.75 54.25L286.5 55.25L288.5 55.75H293.25L295.5 55.25L297 54.5L297.5 53.75V48.5L296.25 48.25L294.25 49H292L290.75 48.5L289.5 47L289.25 31L290.25 30.25H297.25L297.75 29.75V24.25L297.25 23.75L289.75 23.5L289.25 23V15.75L288.75 15.25L282.75 15ZM124.25 12.5V19.25L131.5 19.5L132.25 19L132.5 13L132 12.5H124.25ZM172.25 12L165 12.25L164.75 27L164.25 27.25L162.25 25.5L159.25 23.75L153.75 23L150.5 23.5L147.5 24.75L145 26.5L142.25 29.75L141 32.25L140 35.75L139.75 40.75L140.25 44.5L142.25 49.25L146 53.25L147.5 54.25L152.75 56H156.25L161.25 54.25L163.75 52L164.5 51.75L165 52.25L165.25 55.25H172L172.5 54.75L172.25 12ZM154.75 29.75H157.5L161 31.25L164 34.75L165 38V41.25L163.25 45.5L160.25 48.25L156.75 49.5L154.5 49.25L151.25 47.75L148.5 44.5L147.5 41.5V37.5L148.75 34L151.25 31.25L154.75 29.75ZM270.25 11.75L263.5 12L263.25 12.5V54.75L263.75 55.25L270.75 55V12.25L270.25 11.75ZM65.75 10.5L64.5 10L63.5 11L39.5 43L38.25 42.25L28.75 27.75V27.25L27.25 25.5L26.5 25.75L21.25 31.25L21.5 32.5L34 51.75L36 54.25H41.75L42.75 53.25L71 15.75V14.75L65.75 10.5ZM37.25 0L30.5 0.75L22.25 3.5L15.75 7.25L10.5 11.75L6.25 17L3.25 22.25L1 29L0.25 33L0 37.75L1 46L3.25 52.5L7.25 59.25L12.5 65L16.25 68L19.5 70L26.5 73L31.5 74.25L35.5 74.75H41.25L45.5 74.25L49.5 73.25L56 70.75L59.25 69L64.5 65L66.75 62.75L66.5 61.75L61 57H60L58 59L53 62.5L49.25 64.25L45.25 65.5L37.25 66.25L31.5 65.5L30 64.75L28.25 64.5L22.25 61.5L19 59L15.75 55.75L13 52L10.75 47.5L9 40.5V34.5L9.75 30.25L10.75 27.25L13.5 22L16.5 18.25L19.75 15.25L22.5 13.25L26.75 11L32 9.25L36 8.75H41L45 9.25L47.75 10.25H49.5L54.25 4.25L54 3.25L50.25 1.75L44.5 0.5L37.25 0Z" fill="white"/>
</svg>`;

function esc(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function escMultiline(value: unknown): string {
  return esc(value).replace(/\n/g, '<br>');
}

function asArray(value: any): any[] {
  if (Array.isArray(value)) return value;
  if (!value) return [];
  return [value];
}

function firstText(value: any): string {
  if (Array.isArray(value)) return String(value[0] || '').trim();
  return String(value || '').trim();
}

function joinValues(value: unknown): string {
  if (Array.isArray(value)) {
    return value.map((item) => String(item ?? '').trim()).filter(Boolean).join(', ');
  }
  return String(value ?? '').trim();
}

function formatFullDate(raw?: string): string {
  if (!raw) return '';
  const ymd = String(raw).match(/^(\d{4}-\d{2}-\d{2})/);
  const date = new Date(ymd ? `${ymd[1]}T00:00:00` : raw);
  if (isNaN(date.getTime()) || date.getFullYear() < 1900) return '';
  return date.toLocaleDateString('lt-LT');
}

function asLines(value: unknown): string[] {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value.map((item) => String(item ?? '').trim()).filter(Boolean);
  }
  return String(value)
    .split(/\n/)
    .map((line) => line.replace(/^[•*-]\s*/, '').trim())
    .filter(Boolean);
}

function listHtml(items: string[]): string {
  if (!items.length) return '';
  if (items.length === 1) return `<p class="entry-body">${escMultiline(items[0])}</p>`;
  return `<ul class="entry-list">${items.map((item) => `<li>${esc(item)}</li>`).join('')}</ul>`;
}

function kvHtml(rows: Array<[string, string]>): string {
  const filled = rows.filter(([, value]) => value);
  if (!filled.length) return '';
  return `<dl class="kv">${filled.map(([label, value]) =>
    `<div class="kv-row"><dt>${esc(label)}</dt><dd>${esc(value)}</dd></div>`
  ).join('')}</dl>`;
}

function formatMonthYear(raw?: string): string {
  if (!raw) return '';
  const value = String(raw).trim();
  if (!value) return '';
  if (/^\d{4}$/.test(value)) return value;
  const date = new Date(value);
  if (isNaN(date.getTime()) || date.getFullYear() < 1900) return value;
  return date.toLocaleDateString('lt-LT', { year: 'numeric', month: 'short' });
}

function formatPeriod(start?: string, end?: string, fallback?: string): string {
  if (fallback) return fallback;
  const from = formatMonthYear(start);
  if (!from && !end) return '';
  const to = end ? formatMonthYear(end) : 'dabar';
  return from ? `${from} – ${to}` : to;
}

function resolveImageUrl(raw?: string | null): string {
  if (!raw) return '';
  if (raw.startsWith('http') || raw.startsWith('data:')) return raw;
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  const origin = apiUrl.replace(/\/api\/?$/, '');
  const path = raw.startsWith('/') ? raw : `/uploads/cvs/${raw}`;
  return `${origin}${path}`;
}

function desiredPosition(cv: any): string {
  const prefs = cv.job_preferences || {};
  if (Array.isArray(prefs.items) && prefs.items.length) {
    const names = prefs.items.map((item: any) => joinValues(item.position)).filter(Boolean);
    if (names.length) return Array.from(new Set(names)).join(', ');
  }
  return joinValues(prefs.position) || firstText(prefs.desiredPosition);
}

function formatSalary(pref: any): string {
  if (!pref) return '';
  if (pref.salary) return String(pref.salary);
  const min = pref.salaryMin;
  const max = pref.salaryMax;
  if (min && max) return `nuo ${min} iki ${max} EUR`;
  if (min) return `nuo ${min} EUR`;
  if (max) return `iki ${max} EUR`;
  return '';
}

function desiredJobRows(pref: any): Array<[string, string]> {
  if (!pref) return [];
  return [
    ['Pareigybės', joinValues(pref.position || pref.desiredPosition)],
    ['Pareigybių tipas', joinValues(pref.positionType)],
    ['Darbo sritis', joinValues(pref.workField)],
    ['Vieta', joinValues(pref.workLocation || pref.location || pref.desiredLocation)],
    ['Darbo tipas', joinValues(pref.workType || pref.type || pref.desiredWorkType)],
    ['Darbo laikas', joinValues(pref.workTime || pref.time || pref.desiredWorkTime)],
    ['Atlyginimas (netto)', formatSalary(pref)],
  ];
}

function freelanceRow(cv: any): string {
  if (!cv?.accept_gigs) return '';
  return `<p class="freelance-opt-in">✓ Priima Freelance pasiūlymus</p>`;
}

function desiredJobHtml(cv: any): string {
  const prefs = cv.job_preferences;
  if (!prefs) return '';
  const items = Array.isArray(prefs.items) && prefs.items.length ? prefs.items : [prefs];
  return items.map((item: any) => {
    const body = kvHtml(desiredJobRows(item));
    return body ? `<article class="entry">${body}</article>` : '';
  }).join('');
}

function languageLine(lang: any): string {
  const name = lang.language || lang.name || '';
  const parts = [lang.understanding, lang.speaking, lang.writing, lang.level]
    .map((part: any) => String(part || '').trim())
    .filter(Boolean);
  if (lang.isNative) parts.unshift('Gimtoji');
  return parts.length ? `${name} — ${parts.join(' · ')}` : name;
}

function flattenComputerSkills(skills: any): string[] {
  if (!skills) return [];
  const items = Array.isArray(skills)
    ? skills
    : Object.values(skills).flatMap((group: any) => asArray(group));
  return items
    .map((s: any) => {
      if (typeof s === 'string') return s;
      const name = s?.name || s?.skill || '';
      if (!name) return '';
      return s?.level ? `${name} (${s.level})` : name;
    })
    .filter(Boolean);
}

function drivingLabels(skills: any): string[] {
  return asArray(skills)
    .map((s) => {
      if (typeof s === 'string') return s;
      if (s?.selected === false) return '';
      const category = s?.category || s?.name || '';
      if (!category) return '';
      return s?.experience ? `${category} · stažas ${s.experience}` : category;
    })
    .filter(Boolean);
}

function section(title: string, body: string): string {
  if (!body.trim()) return '';
  return `<section class="section"><h2>${esc(title)}</h2>${body}</section>`;
}

/**
 * A4 print document for a CV. Uses hardcoded brand teal because the print
 * window has no app CSS variables (same constraint as HTML email).
 */
export function generatePrintableCV(cv: any): string {
  const name = `${cv.first_name || ''} ${cv.last_name || ''}`.trim() || 'CV';
  const role = desiredPosition(cv);
  const photo = resolveImageUrl(cv.profile_image_url);
  const city = cv.location || cv.address || '';
  const born = formatFullDate(cv.birth_date);
  const contacts = [cv.email, cv.phone, city, born && `Gimimo data: ${born}`].filter(Boolean).map(esc);
  const desiredJob = desiredJobHtml(cv);

  const experience = asArray(cv.work_experience).map((exp) => {
    const title = exp.position || 'Pareigybė';
    const company = exp.companyName || exp.company || '';
    const period = formatPeriod(exp.startDate, exp.endDate, exp.period);
    const meta = [
      exp.companyActivity || exp.companyField ? `Įmonės veiklos sritis: ${exp.companyActivity || exp.companyField}` : '',
      exp.workField ? `Darbo sritis: ${exp.workField}` : '',
      exp.website || exp.companyWebsite ? exp.website || exp.companyWebsite : '',
    ].filter(Boolean);
    const duties = asLines(exp.responsibilities || exp.description);
    const achievements = asLines(exp.achievements);
    return `<article class="entry">
      <div class="entry-top">
        <div>
          <div class="entry-title">${esc(title)}</div>
          ${company ? `<div class="entry-sub">${esc(company)}</div>` : ''}
          ${meta.length ? `<div class="entry-meta">${meta.map((line) => esc(line)).join(' · ')}</div>` : ''}
        </div>
        ${period ? `<div class="entry-period">${esc(period)}</div>` : ''}
      </div>
      ${duties.length ? listHtml(duties) : ''}
      ${achievements.length ? `<div class="entry-label">Pasiekimai</div>${listHtml(achievements)}` : ''}
    </article>`;
  }).join('');

  const education = asArray(cv.education).map((edu) => {
    const title = [edu.educationType, edu.specialization, edu.field, edu.degree].filter(Boolean).join(', ')
      || 'Išsilavinimas';
    const period = formatPeriod(edu.startDate || edu.startYear, edu.endDate || edu.endYear, edu.period || edu.year);
    return `<article class="entry">
      <div class="entry-top">
        <div>
          <div class="entry-title">${esc(title)}</div>
          ${edu.institution ? `<div class="entry-sub">${esc(edu.institution)}</div>` : ''}
        </div>
        ${period ? `<div class="entry-period">${esc(period)}</div>` : ''}
      </div>
    </article>`;
  }).join('');

  const training = asArray(cv.additional_training).map((item) => {
    const title = item.course || item.title || item.courseName || item.name || 'Mokymai';
    const org = item.institution || item.organizer || item.organization || item.provider || '';
    const period = formatPeriod(item.startDate, item.endDate, item.year || item.period);
    const duration = item.duration ? `Trukmė ${item.duration}` : '';
    return `<article class="entry">
      <div class="entry-top">
        <div>
          <div class="entry-title">${esc(title)}</div>
          ${org ? `<div class="entry-sub">${esc(org)}</div>` : ''}
        </div>
        ${period || duration ? `<div class="entry-period">${esc([period, duration].filter(Boolean).join(' · '))}</div>` : ''}
      </div>
    </article>`;
  }).join('');

  const organizations = asArray(cv.organization_memberships).map((org) => {
    const period = formatPeriod(org.startDate, org.endDate, org.period);
    return `<article class="entry">
      <div class="entry-top">
        <div>
          <div class="entry-title">${esc(org.name || 'Organizacija')}</div>
          ${org.status ? `<div class="entry-sub">${esc(org.status)}</div>` : ''}
        </div>
        ${period ? `<div class="entry-period">${esc(period)}</div>` : ''}
      </div>
    </article>`;
  }).join('');

  const recommendations = asArray(cv.recommendations).map((rec) => {
    const who = rec.personName || rec.name || 'Rekomendacija';
    const body = kvHtml([
      ['Įmonė', rec.company || ''],
      ['Pareigos', rec.position || ''],
      ['Telefonas', rec.phone || ''],
      ['El. paštas', rec.email || ''],
    ]);
    return `<article class="entry">
      <div class="entry-title">${esc(who)}</div>
      ${body}
    </article>`;
  }).join('');

  const languages = asArray(cv.language_skills)
    .map(languageLine)
    .filter(Boolean)
    .map((line) => `<span class="chip">${esc(line)}</span>`)
    .join('');

  const native = cv.native_language
    ? `<span class="chip">Gimtoji: ${esc(cv.native_language)}</span>`
    : '';

  const itSkills = flattenComputerSkills(cv.computer_skills)
    .map((s) => `<span class="chip">${esc(s)}</span>`)
    .join('');

  const driving = drivingLabels(cv.driving_skills)
    .map((s) => `<span class="chip">${esc(s)}</span>`)
    .join('');

  const extraLicenses = [
    cv.driving_experience && `Vairavimo stažas: ${cv.driving_experience}`,
    cv.has_forklift_license && 'Krautuvo pažymėjimas',
    cv.has_electric_forklift_license && 'Elektrokrautuvo pažymėjimas',
    cv.use_own_car && 'Naudoja asmeninį automobilį',
  ].filter(Boolean).map((s) => `<span class="chip">${esc(s)}</span>`).join('');

  return `<!DOCTYPE html>
<html lang="lt">
<head>
  <meta charset="utf-8">
  <title>${esc(name)} – CV</title>
  <style>
    * { box-sizing: border-box; margin: 0; padding: 0; }
    @page { size: A4; margin: 12mm 14mm; }
    body {
      font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
      color: #2d3748;
      font-size: 12px;
      line-height: 1.5;
      background: #fff;
    }
    .header {
      background: ${BRAND};
      color: #fff;
      padding: 22px 24px;
      display: flex;
      justify-content: space-between;
      gap: 20px;
      align-items: flex-start;
    }
    .brand { display: flex; align-items: center; gap: 8px; margin-bottom: 14px; opacity: 0.95; }
    .brand span { font-size: 11px; letter-spacing: 0.4px; }
    .name { font-size: 26px; font-weight: 700; letter-spacing: -0.4px; line-height: 1.15; }
    .role { margin-top: 4px; font-size: 14px; font-weight: 500; opacity: 0.92; }
    .contacts { margin-top: 12px; font-size: 12px; opacity: 0.92; }
    .freelance-opt-in {
      display: inline-block;
      margin-top: 10px;
      padding: 4px 10px;
      background: #ffffff;
      color: ${BRAND};
      border-radius: 4px;
      font-size: 12px;
      font-weight: 700;
    }
    .photo {
      width: 88px; height: 88px; border-radius: 8px; object-fit: cover;
      border: 3px solid rgba(255,255,255,0.35); flex-shrink: 0; background: ${BRAND_DARK};
    }
    .body { padding: 22px 8px 8px; }
    .section { margin-bottom: 18px; }
    .section h2 {
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: ${BRAND};
      border-bottom: 2px solid ${BRAND};
      padding-bottom: 5px;
      margin-bottom: 10px;
    }
    .prose { color: #4a5568; }
    .entry { margin-bottom: 12px; page-break-inside: avoid; }
    .entry-top { display: flex; justify-content: space-between; gap: 16px; align-items: baseline; }
    .entry-title { font-size: 13px; font-weight: 700; color: #1a202c; }
    .entry-sub { font-size: 12px; color: ${BRAND_DARK}; font-weight: 600; margin-top: 1px; }
    .entry-period { font-size: 11px; color: #718096; white-space: nowrap; }
    .entry-body { margin-top: 4px; color: #4a5568; }
    .entry-meta { margin-top: 2px; font-size: 11px; color: #718096; }
    .entry-label { margin-top: 6px; font-size: 11px; font-weight: 700; color: #4a5568; }
    .entry-list { margin: 4px 0 0 18px; color: #4a5568; }
    .entry-list li { margin-bottom: 2px; }
    .kv { display: grid; gap: 4px; }
    .kv-row { display: grid; grid-template-columns: 160px 1fr; gap: 8px; }
    .kv-row dt { color: #718096; font-weight: 600; }
    .kv-row dd { color: #1a202c; }
    .chips { display: flex; flex-wrap: wrap; gap: 6px; }
    .chip {
      display: inline-block;
      padding: 4px 9px;
      background: #f0faf9;
      color: ${BRAND_DARK};
      border-radius: 4px;
      font-size: 11px;
      font-weight: 600;
    }
    .footer {
      margin-top: 20px;
      padding-top: 10px;
      border-top: 1px solid #e2e8f0;
      display: flex;
      justify-content: space-between;
      font-size: 10px;
      color: #a0aec0;
    }
    @media print {
      body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      .header { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
    }
  </style>
</head>
<body>
  <header class="header">
    <div>
      <div class="brand">${LOGO_SVG}<span>cvgidas.lt</span></div>
      <div class="name">${esc(name)}</div>
      ${role ? `<div class="role">${esc(role)}</div>` : ''}
      ${contacts.length ? `<div class="contacts">${contacts.join(' · ')}</div>` : ''}
      ${freelanceRow(cv)}
    </div>
    ${photo ? `<img class="photo" src="${esc(photo)}" alt="">` : ''}
  </header>
  <main class="body">
    ${cv.description ? section('Apie mane', `<p class="prose">${escMultiline(cv.description)}</p>`) : ''}
    ${experience ? section('Darbo patirtis', experience) : ''}
    ${education ? section('Išsilavinimas', education) : ''}
    ${training ? section('Papildomi mokymai', training) : ''}
    ${native || languages ? section('Kalbos', `<div class="chips">${native}${languages}</div>`) : ''}
    ${itSkills ? section('IT įgūdžiai', `<div class="chips">${itSkills}</div>`) : ''}
    ${driving || extraLicenses ? section('Vairavimas', `<div class="chips">${driving}${extraLicenses}</div>`) : ''}
    ${cv.personal_qualities ? section('Asmeninės savybės', `<p class="prose">${escMultiline(cv.personal_qualities)}</p>`) : ''}
    ${cv.hobbies ? section('Pomėgiai', `<p class="prose">${escMultiline(cv.hobbies)}</p>`) : ''}
    ${organizations ? section('Narystė organizacijose', organizations) : ''}
    ${recommendations ? section('Rekomendacijos', recommendations) : ''}
    ${desiredJob ? section('Pageidaujamas darbas', desiredJob) : ''}
    <div class="footer">
      <span>cvgidas.lt</span>
      <span>Sugeneruota ${new Date().toLocaleDateString('lt-LT')}</span>
    </div>
  </main>
</body>
</html>`;
}
